import { render, staticRenderFns } from "./vtableDashboard.vue?vue&type=template&id=4e9586c1&"
import script from "./vtableDashboard.vue?vue&type=script&lang=js&"
export * from "./vtableDashboard.vue?vue&type=script&lang=js&"
import style0 from "./vtableDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports